<!-- <template> -->
  <!-- <div id="app"> -->
    <!-- <router-view></router-view> -->
  <!-- </div> -->
<!-- // </template> -->
<template>
  <div id="app">
    <!-- 可以被缓存的视图组件 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!-- 不可以被缓存的视图组件 -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
// import {GetAxios} from "../static/js/common";

export default {
  name: 'App',
  created() {

  },
  methods: {}
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-width: 1240px;
}

@media screen and (min-width: 320px)and (max-width: 750px) {
  #app {
    min-width: 320px;
  }
}

* {
  margin: 0;
  padding: 0;
}

/**
.on-leave-active {
  transition: .2s ease;
}
 */

</style>



// WEBPACK FOOTER //
// src/App.vue